// extracted by mini-css-extract-plugin
export var actions = "_1v-0";
export var actionsContainer = "_1v-7";
export var border = "_1v-1";
export var childFullHeight = "_1v-f";
export var collapse = "_1v-2";
export var content = "_1v-a";
export var contentChild = "_1v-e";
export var fullscreen = "_1v-c";
export var hasLeftRadius = "_1v-k";
export var headerContainer = "_1v-3";
export var headerRow = "_1v-5";
export var hidePadding = "_1v-b";
export var navCollapsedGap = "_1v-l";
export var noScrollX = "_1v-m";
export var noScrollY = "_1v-n";
export var noTopPadding = "_1v-i";
export var optOutTopPadding = "_1v-d";
export var pageMain = "_1v-j";
export var pageOuter = "_1v-g";
export var pagePadding = "_1v-8";
export var pageScroll = "_1v-9";
export var profile = "_1v-o";
export var profileContainer = "_1v-p";
export var profileImage = "_1v-q";
export var profileMain = "_1v-r";
export var profileSubtitle = "_1v-t";
export var profileTitle = "_1v-s";
export var showLeftPadding = "_1v-h";
export var tabsPortalSlot = "_1v-6";
export var tabsWrapper = "_1v-4";
export var title = "_1v-u";